import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/MARCA-STED.png'


const _hoisted_1 = { class: "flex align-items-center justify-content-center h-6rem surface-border flex-shrink-0 overflow-hidden" }
const _hoisted_2 = { class: "flex align-items-center justify-content-center w-full h-full" }
const _hoisted_3 = { class: "flex-1 overflow-y-auto overflow-x-hidden custom-scrollbar" }
const _hoisted_4 = ["href", "onClick"]
const _hoisted_5 = { class: "flex align-items-center flex-1" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "md:hidden border-top-1 surface-border p-3 mt-auto"
}
const _hoisted_8 = { class: "flex flex-column" }
const _hoisted_9 = { class: "font-bold text-color" }
const _hoisted_10 = { class: "text-sm text-color-secondary" }
const _hoisted_11 = { class: "flex flex-column gap-2" }

import RoleSwitcher from '@/components/RoleSwitcher.vue'
import { usePermissions } from '@/composables/usePermissions'
import { useCoordenadorAvisosBadge } from '@/composables/coordenador/useCoordenadorAvisosBadge'
import { useDefesaRevisao } from '@/composables/defesas/useDefesaRevisao'
import { useCursoStore } from '@/stores/CursoStore'
import { useLogout } from '@/composables/useLogout'
import { useAuthStore } from '@/stores/AuthStore'
import { useThemeStore } from '@/stores/ThemeStore'
import Avatar from 'primevue/avatar'
import Badge from 'primevue/badge'
import Button from 'primevue/button'
import Menu from 'primevue/menu'
import { useConfirm } from 'primevue/useconfirm'
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'Sidebarmenu',
  setup(__props, { expose: __expose }) {

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()
const themeStore = useThemeStore()
const confirm = useConfirm()
const { sair } = useLogout()
const { can } = usePermissions()

const themeToggleIcon = computed(() => themeStore.isDark ? "pi pi-sun" : "pi pi-moon")
const toggleTheme = () => themeStore.toggleTheme()

const userInitials = computed(() => {
    const name = authStore.user?.name || 'U';
    return name
        .split(' ')
        .map((n: string) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
});

const isMobile = ref(window.innerWidth <= 768)
const isOpen = ref(!isMobile.value)

const handleResize = () => {
    const mobile = window.innerWidth <= 768
    if (mobile !== isMobile.value) {
        isMobile.value = mobile
        isOpen.value = !mobile
    }
}

const handleMobileClick = () => {
    if (isMobile.value) {
        isOpen.value = false
    }
}

const handleMenuCommand = (item: any) => {
    if (typeof item?.command === 'function') {
        item.command({ originalEvent: new MouseEvent('click'), item } as any)
    }
}

onMounted(() => {
    window.addEventListener('resize', handleResize)
    if (authStore.isOrientador) {
        carregarDefesas()
    }
    if (isPerfilCoordenacao.value) {
        carregarResumoAvisos()
    }
})

onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
})

const { totalPendentes, carregarDefesas } = useDefesaRevisao()
const defesasPendentesCount = computed(() => totalPendentes.value)
const { totalAvisos, carregarResumoAvisos } = useCoordenadorAvisosBadge()
const isPerfilCoordenacao = computed(() => authStore.isCoordenador || authStore.isSecretaria || authStore.isCoordenadorTcc)

const dashboardMenuText = computed(() => {
    if (authStore.isCoordenador || authStore.isSecretaria || authStore.isCoordenadorTcc) {
        return 'Gerenciar trabalhos'
    }
    if (authStore.isAluno) {
        return 'Meus Projetos'
    }
    return 'Modelos/Projetos'
})

const menuItems = computed(() => {
    const items = []

    // Admin
    if (authStore.isAdmin) {
        items.push({
            label: 'Administração',
            icon: 'pi pi-shield',
            to: '/admin'
        })
    }

    // Orientador
    if (authStore.isOrientador && !authStore.isAdmin && !authStore.isCoordenador && !authStore.isSecretaria) {
        items.push({
            label: 'Painel Orientador',
            icon: 'pi pi-briefcase',
            to: '/painel-orientador'
        })
        items.push({
            label: 'Revisão Defesas',
            icon: 'pi pi-file-check',
            to: '/defesas',
            badge: defesasPendentesCount.value > 0 ? defesasPendentesCount.value : null
        })
    }

    // Coordenador, Secretaria e Coordenador TCC (Gestão de Normas)
    if (authStore.isCoordenador || authStore.isSecretaria || authStore.isCoordenadorTcc) {
        items.push({
            label: 'Gerenciar trabalhos',
            icon: 'pi pi-briefcase',
            to: '/gerenciar-trabalhos'
        })
        if (!authStore.isCoordenadorTcc) {
            items.push({
                label: 'Gerenciar Professores',
                icon: 'pi pi-users',
                to: '/gerenciar-professores'
            })
        }
        items.push({
            label: 'Normas TCC / Links',
            icon: 'pi pi-book',
            to: '/gerenciar-normas-tcc'
        })
        items.push({
            label: 'Avisos',
            icon: 'pi pi-bell',
            to: '/avisos',
            badge: totalAvisos.value > 0 ? totalAvisos.value : null
        })
    }

    // Aluno
    if (authStore.isAluno && !authStore.isAdmin && !authStore.isCoordenador && !authStore.isSecretaria && !authStore.isOrientador) {
        items.push({
            label: dashboardMenuText.value,
            icon: 'pi pi-folder',
            to: '/projetos'
        })
    }

    // User Normal
    if (authStore.isUserNormal && !authStore.isAdmin && !authStore.isCoordenador && !authStore.isSecretaria && !authStore.isOrientador && !authStore.isAluno) {
        items.push({
            label: 'Meus Projetos',
            icon: 'pi pi-folder',
            to: '/projetos'
        })
    }

    // Acompanhamento
    if (authStore.isAluno && !authStore.isOrientador) {
        items.push({
            label: 'Acompanhamento',
            icon: 'pi pi-list-check',
            to: '/acompanhamento'
        })
    }

    // Normas TCC / Links (leitura — APENAS para Alunos)
    if (authStore.isAluno && !authStore.isCoordenador && !authStore.isSecretaria && !authStore.isCoordenadorTcc) {
        items.push({
            label: 'Normas TCC / Links',
            icon: 'pi pi-book',
            to: '/normas-tcc'
        })
    }

    // Events
    items.push({
        label: 'Eventos',
        icon: 'pi pi-calendar',
        to: '/eventos'
    })

    // Comuns
    items.push({
        label: 'Tutoriais',
        icon: 'pi pi-video',
        to: '/tutoriais'
    })

    // Log do sistema (fora do if de admin: a permissão existe separada
    // justamente para poder ser concedida a quem não é admin, ex.: coordenador).
    // Fica por último, depois dos Tutoriais: é consulta ocasional, não rotina.
    if (can('sistema.logs')) {
        items.push({
            label: 'Log do sistema',
            icon: 'pi pi-history',
            to: '/logs'
        })
    }

    items.push({
        label: 'Sair',
        icon: 'pi pi-sign-out',
        command: handleLogout
    })

    return items
})

const visibleRoutes = ['/projetos', '/eventos', '/tutoriais', '/acompanhamento', '/conta', '/gerenciar-trabalhos', '/gerenciar-professores', '/gerenciar-normas-tcc', '/avisos', '/normas-tcc', '/painel-orientador', '/defesas', '/admin', '/logs', '/coordenador']

const isVisible = computed(() => {
    // Ocultar sidebar em todas as rotas do editor
    if (route.name === 'editor' || route.name === 'orientador-editor' || route.path.includes('/editor/')) {
        return false
    }

    return visibleRoutes.some(routePath =>
        route.path === routePath || route.path.startsWith(routePath)
    )
})

const cursoStore = useCursoStore()
watch(() => cursoStore.cursoAtual?.id, () => {
    if (isPerfilCoordenacao.value) {
        carregarResumoAvisos()
    }
})

watch(() => route.path, (newPath, oldPath) => {
    if (isPerfilCoordenacao.value && oldPath !== newPath) {
        carregarResumoAvisos()
    }
    if (authStore.isOrientador) {
        if (oldPath === '/orientador/defesas' && newPath !== '/orientador/defesas') {
            carregarDefesas()
        }
        if (newPath.startsWith('/orientador') && oldPath !== newPath) {
            carregarDefesas()
        }
    }
})

const isActiveRoute = (routePath: string): boolean => {
    if (routePath === '/projetos' && route.path === '/projetos') {
        return true
    }

    if (routePath === '/painel-orientador') {
        return route.path === '/painel-orientador'
    }

    if (routePath === '/defesas') {
        return route.path === '/defesas'
    }

    if (routePath === '/gerenciar-trabalhos') {
        return route.path === '/gerenciar-trabalhos' || route.path.startsWith('/gerenciar-trabalhos/')
    }

    if (routePath === '/gerenciar-professores') {
        return route.path === '/gerenciar-professores'
    }

    if (routePath === '/admin') {
        return route.path === '/admin' || route.path.startsWith('/admin/')
    }
    return route.path === routePath || route.path.startsWith(routePath + '/')
}

const handleLogout = (): void => {
    confirm.require({
        message: 'Deseja realmente sair do sistema?',
        header: 'Confirmar Saída',
        style: { width: '500px', height: '163px' },
        pt: {
            closeButton: {
                root: { class: 'hidden' }
            }
        },
        rejectProps: {
            label: 'Cancelar',
            style: {
                backgroundColor: 'white',
                borderColor: '#822133',
                color: '#822133'
            }
        },
        acceptProps: {
            label: 'Sair',
            style: {
                backgroundColor: '#822133',
                borderColor: '#822133',
                color: 'white'
            }
        },
        accept: async () => {
            await sair()
            confirm.close()
        }
    } as any)
}

const toggleSidebar = (): void => {
    isOpen.value = !isOpen.value
}

__expose({
    toggleSidebar,
    isOpen,
    isVisible
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isVisible.value && isOpen.value && isMobile.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed top-0 left-0 w-full h-full",
          style: {"background-color":"rgba(0,0,0,0.4)","z-index":"998"},
          onClick: toggleSidebar
        }))
      : _createCommentVNode("", true),
    (isVisible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["sidebar-menu flex flex-column surface-card surface-border transition-all transition-duration-300 flex-shrink-0 border-round-lg", [isOpen.value ? 'w-14rem' : 'w-4rem', { 'mobile-open': isOpen.value }]]),
          style: {"height":"100%"}
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "STED logo",
                class: "transition-all transition-duration-300 mt-1",
                style: _normalizeStyle({ width: isOpen.value ? '140px' : '60px', height: isOpen.value ? '90px' : '50px', objectFit: 'contain' })
              }, null, 4)
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Menu), {
              model: menuItems.value,
              class: "w-full border-none bg-transparent p-0"
            }, {
              item: _withCtx(({ item, props }) => [
                (item.to)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: item.to,
                      custom: ""
                    }, {
                      default: _withCtx(({ href, navigate, isActive }) => [
                        _createElementVNode("a", {
                          href: href,
                          onClick: (e) => { navigate(e); handleMobileClick() },
                          class: _normalizeClass(["nav-link", { 'active-link': isActive || isActiveRoute(item.to) }])
                        }, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("i", {
                              class: _normalizeClass([item.icon, 'text-xl'])
                            }, null, 2),
                            _withDirectives(_createElementVNode("span", { class: "font-medium text-sm white-space-nowrap ml-3" }, _toDisplayString(item.label), 513), [
                              [_vShow, isOpen.value]
                            ])
                          ]),
                          (item.badge)
                            ? (_openBlock(), _createBlock(_unref(Badge), {
                                key: 0,
                                value: item.badge,
                                severity: "danger",
                                class: _normalizeClass(["badge-pendentes", { 'absolute top-0 right-0 m-1': !isOpen.value }])
                              }, null, 8, ["value", "class"]))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_4)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "nav-link cursor-pointer",
                      onClick: ($event: any) => (handleMenuCommand(item))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass([item.icon, 'text-xl'])
                      }, null, 2),
                      _withDirectives(_createElementVNode("span", { class: "font-medium text-sm white-space-nowrap ml-3" }, _toDisplayString(item.label), 513), [
                        [_vShow, isOpen.value]
                      ])
                    ], 8, _hoisted_6))
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          (isOpen.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "flex align-items-center gap-3 mb-3 cursor-pointer hover:surface-hover p-2 border-round transition-colors transition-duration-200",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {_unref(router).push('/conta'); handleMobileClick()})
                }, [
                  _createVNode(_unref(Avatar), {
                    label: userInitials.value,
                    class: "surface-200 text-color",
                    size: "large",
                    shape: "circle"
                  }, null, 8, ["label"]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(authStore).user?.name), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(authStore).activeRole), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(RoleSwitcher, { class: "w-full" }),
                  _createVNode(_unref(Button), {
                    icon: themeToggleIcon.value,
                    label: "Alternar Tema",
                    outlined: "",
                    class: "w-full justify-content-start",
                    onClick: toggleTheme
                  }, null, 8, ["icon"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: toggleSidebar,
            class: "absolute flex align-items-center justify-content-center surface-card border-1 surface-border border-circle cursor-pointer shadow-2 text-500 hover:text-primary transition-colors transition-duration-200 outline-none hidden md:flex",
            style: {"top":"50%","right":"-15px","width":"30px","height":"30px","transform":"translateY(-50%)","z-index":"1000"}
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(isOpen.value ? 'pi pi-angle-left' : 'pi pi-angle-right')
            }, null, 2)
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})